// extracted by mini-css-extract-plugin
export default {"Container":"Submit_Container__9xbQO","TextContainer":"Submit_TextContainer__SNl1G","Header":"Submit_Header__CYhZt","Content":"Submit_Content__7RyZN"};